import { render, staticRenderFns } from "./BusSeat.vue?vue&type=template&id=601d65e8"
import script from "./BusSeat.vue?vue&type=script&lang=js"
export * from "./BusSeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports